function initSearch(){
    $('.mrk-search-form [type="reset"]').on('click', function(){
        setTimeout(function(){
            $('.mrk-search-form input[type="search"]').trigger('input');
        },150)
    });
    $('.mrk-search-form').on('submit', function(e){
        e.preventDefault();
        $('.mrk-search-form input[type="search"]').trigger('input')
    });
    $('.mrk-search-form input[type="search"]').on('input', function(e) {
        $('.mrk-services-page').addClass('is-loading');
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function() {
            if (requestInProgress) {
                return;
            }
            e.preventDefault();
            var form = $('.mrk-search-form');
            if($('.mrk-search-form input[type="search"]').val().length>0){
                var url = form.attr('action') + '?' + form.serialize();
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).filter('.mrk-products').html();
                        const pagination = $(html).filter('.pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-pagination').html(pagination);
                        $('.mrk-services-page').removeClass('is-loading');
                        initAdditionalFunctionality();
                        AOS.refreshHard();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }else{
                var url = location.pathname+location.search;
                $('.mrk-services-page').addClass('is-loading');
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).find('.mrk-product-list').html();
                        const pagination = $(html).find('.mrk-pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-pagination').html(pagination);
                        AOS.refreshHard();
                        $('.mrk-services-page').removeClass('is-loading');
                        initAdditionalFunctionality();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }
        }, 1000);  // Delay of 2 seconds
    });
}
var debounceTimeout;
var requestInProgress = false;


function initAdditionalFunctionality() {
    var showMoreBtn = $("#show-more-btn");
    var showLessBtn = $("#show-less-btn");
    var productItems = $('.services-product-grid');
    var productsPerPage = 9;

    for (var i = productsPerPage; i < productItems.length; i++) {
        $(productItems[i]).css('display', 'none');
    }
    showMoreBtn.off('click');
    showMoreBtn.on("click", function () {
        productItems.css('display', 'block');
        showMoreBtn.css('display', 'none');
        showLessBtn.css('display', 'inline-block');
        AOS.refreshHard();
    });
    showLessBtn.off('click');
    showLessBtn.on("click", function () {
        for (var i = productsPerPage; i < productItems.length; i++) {
            $(productItems[i]).css('display', 'none');
        }
        showMoreBtn.css('display', 'inline-block');
        showLessBtn.css('display', 'none');
        AOS.refreshHard();
    });
}


$(document).ready(function () {
    initSearch();
    initAdditionalFunctionality();
});